import { render, staticRenderFns } from "./RecreateOnMargModal.vue?vue&type=template&id=2f54bf76&"
import script from "./RecreateOnMargModal.vue?vue&type=script&lang=js&"
export * from "./RecreateOnMargModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports